<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useHotelManagementStore } from '@/store/HotelManagementStore';
import { useToast } from 'primevue/usetoast';
import AutoComplete from 'primevue/autocomplete';
import Button from 'primevue/button';

const emits = defineEmits<{
  foundHotelInfo: [hotelInfo: any];
  clearHotel: [];
  setIsDisabled: [];
}>();

const isDisable = ref(false);
const isLoadingHotelInfo = ref(false);
const isLoadingHotelCode = ref(false);
const hCode = ref<string>('');
const list = ref();
const filterCode = ref([]);
const { t } = useI18n();
const toast = useToast();
const hotelManagementStore = useHotelManagementStore();

const getHotelInfo = async (code: string) => {
  isLoadingHotelInfo.value = true;
  hotelManagementStore
    .getHotelInfo(code)
    .then((res) => {
      isDisable.value = false;
      emits('foundHotelInfo', res?.data);
    })
    .catch((error: Error) => {
      errorHandler(error);
    })
    .finally(() => {
      isLoadingHotelInfo.value = false;
      isDisable.value = true;
    });
};

const getListCode = (event: any) => {
  isLoadingHotelCode.value = true;
  hotelManagementStore
    .getListHotel()
    .then((res) => {
      const result = res.map((item: any) => item.hCode);
      list.value = [...result.slice(0, 100)];
      const query = event.query;
      filterCode.value = list.value.filter((item: string) => {
        return item?.toLowerCase().includes(query);
      });
    })
    .catch((error: Error) => {
      errorHandler(error);
    })
    .finally(() => {
      isLoadingHotelCode.value = false;
    });
};

const removeCode = () => {
  isDisable.value = false;
  hCode.value = '';
  emits('clearHotel');
};

const errorHandler = function (error: Error) {
  if (error.response) {
    const httpCode = error.response.status;
    if (httpCode == 404) {
      emits('foundHotelInfo', { hCode: hCode.value, notExist: true });
      toast.add({ severity: 'success', summary: '', detail: t('notification.not_found_hotel'), life: 3000 });
      emits('setIsDisabled');
    } else {
      toast.add({ severity: 'error', summary: '', detail: t('notification.unexpected_error_http', { httpCode: httpCode }), life: 5000 });
    }
  } else {
    toast.add({ severity: 'error', summary: '', detail: t('notification.unexpected_error'), life: 5000 });
  }
};
</script>

<template>
  <div class="col-8 add-hotel-modal">
    <div class="flex">
      <div class="col-3 pl-0">
        <label for="tss_code">{{ $t('management.hotel.tts_code') }} <span class="text-primary">*</span> </label>
        <AutoComplete :disabled="isDisable" optionLabe="name" v-model="hCode" :suggestions="filterCode" @complete="getListCode" input-class="uppercase" class="w-full" scrollHeight="168px" id="tss_code" />
      </div>
      <div class="btn-get-info">
        <Button data-testid="btn_get_info" :disabled="!hCode || isDisable" :loading="isLoadingHotelInfo" :label="$t('management.hotel.get_hotel_info')" class="p-button-primary mt-1" @click="getHotelInfo(hCode.toUpperCase())" />
        <i class="pi pi-times-circle text-primary text-xl ml-1 cursor-pointer" @click="removeCode()"></i>
      </div>
    </div>
  </div>
</template>
